import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useProjectStore } from '../../store/projectStore';

interface DesignModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DesignModal: React.FC<DesignModalProps> = ({ isOpen, onClose }) => {
  const [designName, setDesignName] = useState('');
  const { currentProject, createDesign } = useProjectStore();

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!currentProject) {
      return;
    }
    const name = designName.trim();
    if (name) {
      createDesign(name);
      onClose();
      setDesignName('');
    }
  };

  const handleClose = () => {
    onClose();
    setDesignName('');
  };

  const isDisabled = !currentProject;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[80]">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md border border-gray-200">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">
            Create New Design
          </h2>
          <button
            onClick={handleClose}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
            title="Close"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6">
          {!currentProject ? (
            <div className="text-sm text-gray-600">
              <p className="mb-2 font-medium">No project is currently open.</p>
              <p>
                Please create or open a project first, then add designs inside
                that project.
              </p>
            </div>
          ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Design Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={designName}
                onChange={(e) => setDesignName(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="e.g., Main Floor Layout"
                required
                autoFocus
              />
            </div>
              <p className="text-xs text-gray-500">
                Design will be created inside project:{' '}
                <span className="font-semibold">
                  {currentProject.name || 'Untitled Project'}
                </span>
              </p>
            </div>
          )}

          {/* Actions */}
          <div className="flex space-x-3 mt-6">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors text-sm font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isDisabled}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300 disabled:cursor-not-allowed transition-colors text-sm font-medium"
            >
              Create Design
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DesignModal;






